var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "icon-track_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38358F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC1FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 59.5,
    cy: 59.5,
    r: 59.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.664 51.442L81.875 61.25l10.79-9.808a5.5 5.5 0 117.672-7.883 5.5 5.5 0 01-7.673 7.883zm-66.339 23.76L51.39 43.853l-25.065 31.35zM22.5 85a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm55-14a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm-18-27.147l14 17.647-14-17.647zM55.5 45a5.5 5.5 0 110-11 5.5 5.5 0 010 11z",
    stroke: "url(#icon-track_svg__a)",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
}

export default SvgIconTrack;